import Vue from "vue"
import VueRouter from "vue-router"
import store from "../store/index"
// Auth root
const Auth = () => import("../views/Auth/Index.vue"),
	Register = () => import("../views/Auth/Registration/Register.vue"),
	ActivateAccount = () =>
		import("../views/Auth/Registration/ActivateAccount.vue"),
	Login = () => import("../views/Auth/Login.vue"),
	ForgotPassword = () => import("../views/Auth/ForgotPassword/Index.vue"),
	ResetPassword = () =>
		import("../views/Auth/ForgotPassword/ResetPassword.vue")

// Home root
const Index = () => import("../views/Index.vue")

Vue.use(VueRouter)

const routes = [
	// Nested Routes
	{
		path: "/auth",
		component: Auth,
		children: [
			{
				path: "register",
				component: Register,
				name: "register",
				meta: {
					auth: true
				}
			},
			{
				path: "activate-account",
				component: ActivateAccount,
				name: "activate-account",
				meta: {
					auth: true
				}
			},
			{
				path: "login",
				component: Login,
				name: "login",
				meta: {
					auth: true
				}
			},
			{
				path: "login/forgot-password",
				component: ForgotPassword,
				name: "forgot-password",
				meta: {
					auth: true
				}
			},
			{
				path: "login/reset-password/:email/:token",
				component: ResetPassword,
				name: "reset-password",
				meta: {
					auth: true
				}
			},
			{
				path: "logout",
				name: "logout",
				beforeEnter: async (to, from, next) => {
					await store.dispatch("login/LOGOUT_USER")
					next({ name: "login" })
				}
			}
		]
	},
	{
		path: "/chat/:nickname?",
		component: Index,
		name: "index",
		meta: {
			// protected: true
		}
	}
]

const router = new VueRouter({
	routes,
	mode: "history"
})

// router.beforeEach((to, from, next) => {
// 	if (to.meta.protected && !store.state.AUTHENTICATED) {
// 		return next({ name: "login" })
// 	} else if (to.meta.auth && store.state.AUTHENTICATED) {
// 		return next({ name: "index" })
// 	}
// 	next()
// })

export default router
